// extracted by mini-css-extract-plugin
export default {"details":"lQkd0","body":"y3507"};